var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 2.66732C15.3333 3.40065 14.7333 4.00065 14 4.00065C13.88 4.00065 13.7666 3.98732 13.66 3.95398L11.2866 6.32065C11.32 6.42732 11.3333 6.54732 11.3333 6.66732C11.3333 7.40065 10.7333 8.00065 9.99996 8.00065C9.26663 8.00065 8.66663 7.40065 8.66663 6.66732C8.66663 6.54732 8.67996 6.42732 8.71329 6.32065L7.01329 4.62065C6.90663 4.65398 6.78663 4.66732 6.66663 4.66732C6.54663 4.66732 6.42663 4.65398 6.31996 4.62065L3.28663 7.66065C3.31996 7.76732 3.33329 7.88065 3.33329 8.00065C3.33329 8.73398 2.73329 9.33398 1.99996 9.33398C1.26663 9.33398 0.666626 8.73398 0.666626 8.00065C0.666626 7.26732 1.26663 6.66732 1.99996 6.66732C2.11996 6.66732 2.23329 6.68065 2.33996 6.71398L5.37996 3.68065C5.34663 3.57398 5.33329 3.45398 5.33329 3.33398C5.33329 2.60065 5.93329 2.00065 6.66663 2.00065C7.39996 2.00065 7.99996 2.60065 7.99996 3.33398C7.99996 3.45398 7.98663 3.57398 7.95329 3.68065L9.65329 5.38065C9.75996 5.34732 9.87996 5.33398 9.99996 5.33398C10.12 5.33398 10.24 5.34732 10.3466 5.38065L12.7133 3.00732C12.68 2.90065 12.6666 2.78732 12.6666 2.66732C12.6666 1.93398 13.2666 1.33398 14 1.33398C14.7333 1.33398 15.3333 1.93398 15.3333 2.66732Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 12.3816H13.0476V14.6673H12.2857V12.3816H10V11.6197H12.2857V9.33398H13.0476V11.6197H15.3333V12.3816Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionOutlined);
export default __webpack_public_path__ + "static/media/Action_outlined.e7785429.svg";
export { ForwardRef as ReactComponent };